import { useEffect, useState } from "react";

import { loadArticlesFromSheet, normaliseArticles } from "../lib/sheets.js";

export default function useArticles() {
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    let ok = true;
    (async () => {
      const raw = await loadArticlesFromSheet();
      if (!ok) return;
      setArticles(normaliseArticles(raw));
    })();
    return () => { ok = false; };
  }, []);
  return articles;
}
